import { render, staticRenderFns } from "./SelectVersion.vue?vue&type=template&id=d6a8b8c0&scoped=true"
import script from "./SelectVersion.vue?vue&type=script&lang=js"
export * from "./SelectVersion.vue?vue&type=script&lang=js"
import style0 from "./SelectVersion.vue?vue&type=style&index=0&id=d6a8b8c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a8b8c0",
  null
  
)

export default component.exports